import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const TasksCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const TaskHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
`;

export const TaskList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
`;

export const TaskItem = styled.a(
    ({ theme: { palette, radius } }) => css`
        align-items: center;
        background-color: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        cursor: pointer;
        display: flex;
        gap: 8px;
        padding: 12px 16px 12px 12px;
        text-decoration: none;
    `,
);

export const TaskItemContent = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    flex-grow: 1;
`;

export const TaskChartWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
`;

export const TaskChart = styled.div`
    display: flex;
    flex-shrink: 0;
    position: relative;
`;

export const TaskStats = styled.div(
    ({ theme: { palette, radius } }) => css`
        border-radius: ${radius[4]}px;
        border: 1px solid ${palette.neutral.dividers};
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px;
    `,
);

export const StatItem = styled.span<{ color: string }>(
    ({ color, theme: { radius } }) => css`
        display: flex;
        align-items: center;
        gap: 8px;

        &::before {
            content: '';
            display: block;
            width: 16px;
            height: 16px;
            background-color: ${color};
            border-radius: ${radius[2]}px;
        }
    `,
);

export const ContentWrapper = styled.div`
    align-items: center;
    display: grid;
    gap: 32px;
    grid-template-columns: repeat(2, 1fr);
`;

export const ChartTextWrapper = styled.div`
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const TasksTitleWrapper = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`;

export const TaskBadge = styled(Typography.TextBody_14_20)(
    ({ theme: { fontWeight, palette, radius } }) => css`
        background-color: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        color: ${palette.secondary.default};
        font-weight: ${fontWeight.bold};
        padding: 2px 16px;
        text-transform: uppercase;
    `,
);

export const AdditionalStatistics = styled.div`
    padding-left: 20px;
`;

export const WarnItem = styled.div`
    align-items: center;
    display: flex;
    gap: 4px;
`;

export const StatsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
